export default __webpack_public_path__ + "static/media/IMG-activityPH_interactive.45fc9b2e.png";